import { createContext, useContext, useMemo } from 'react'
import { cn } from './internal/utils'
import message from './message'
import notification from './notification'
import { confirm, error, info, success, warning } from './internal/modalConfirm'

const modal = { confirm, info, success, error, warning }

const AppContext = createContext({ message, notification, modal })

/**
 * antd App wrapper. The imperative hosts mount themselves on first use, so this
 * only has to provide the context that `App.useApp()` reads.
 */
const App = ({ className, style, component = 'div', children, ...rest }) => {
  const value = useMemo(() => ({ message, notification, modal }), [])
  const Component = component === false ? null : component

  if (!Component) {
    return <AppContext.Provider value={value}>{children}</AppContext.Provider>
  }

  return (
    <AppContext.Provider value={value}>
      <Component className={cn('ui-app', className)} style={style} {...rest}>
        {children}
      </Component>
    </AppContext.Provider>
  )
}

App.useApp = () => useContext(AppContext)

export { AppContext }
export default App
